import { ja } from "date-fns/locale/ja";
import { enUS } from "date-fns/locale/en-US";
import { ko } from "date-fns/locale/ko";
import { zhCN } from "date-fns/locale/zh-CN";
import { zhTW } from "date-fns/locale/zh-TW";

interface ILocales {
  ja: string;
  en: string;
  ko: string;
  zh_cn: string;
  zh_tw: string;
}

export const Locales: ILocales = {
  ja: "ja",
  en: "en",
  ko: "ko",
  zh_cn: "zh_cn",
  zh_tw: "zh_tw",
};

export const LocaleOptions = {
  ja: ja,
  en: enUS,
  ko: ko,
  zh_cn: zhCN,
  zh_tw: zhTW,
};

export const LocaleDisplayName = {
  ja: "日本語",
  en: "English",
  ko: "한국어",
  zh_cn: "简体中文",
  zh_tw: "繁體中文",
};
